import { render } from "./RouwdrukwerkView.vue?vue&type=template&id=a82f39a8"
import script from "./RouwdrukwerkView.vue?vue&type=script&lang=js"
export * from "./RouwdrukwerkView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__